<template>
    <b-container fluid class="headerPushDown ">
        <b-container class="">
            <!-- LOGIN FORM -->
            <form @submit.stop.prevent="handleSubmit">
                <h3 class="text-center text-uppercase">Anmelden</h3>
                <b-form-group >
                    <b-row >
                        <b-col sm="0" md="3">
                        </b-col>
                        <b-col sm="12" md="6" >
                            <label class="text-uppercase mb-0 mt-2">E-Mail Adresse</label>
                            <b-input type="text" size="sm" placeholder="E-Mail" :state="emailState" aria-describedby="input-live-feedback" class="mt-0 InputBorder" v-model="login" id="email"/>
                            <b-form-invalid-feedback id="input-live-feedback" class="mb-2">
                                Bitte eine E-Mail Adresse angeben
                            </b-form-invalid-feedback>

                            <label class="text-uppercase mb-0 mt-2">Passwort</label>
                            <b-input type="password" size="sm" placeholder="Passwort" class="mt-0 mb-3 InputBorder" v-model="password" id="password"/>

                            <!-- LINKs -->
                            <b-row>
                                <b-col cols="6" class="text-center">
                                    <router-link to="/app/register" class="text-uppercase">Neu registrieren</router-link>
                                </b-col>
                                <b-col cols="6" class="text-center">
                                    <router-link to="/app/recover" class="text-uppercase " text-center>Passwort vergessen</router-link>
                                </b-col>
                            </b-row>



                            <b-button type="submit" class="mt-3 text-uppercase" variant="light" block @click.prevent="handleSubmit">ANMELDEN</b-button>

                            <div v-if="this.loginError" class="d-block text-center" v-html="this.loginError"></div>
                        </b-col>
                        <b-col sm="0" md="2">

                        </b-col>

                    </b-row>
                </b-form-group>
            </form>

            <!-- Visual Error -->
            <b-row>
                <b-col sm="0" md="3">
                </b-col>
                <b-col cols="12" md="6">
                    <div v-if="showResendMail">
                        <p class="m-0 p-0 text-uppercase text-danger">
                           Ihre E-Mail Adresse wurde noch nicht bestätigt
                        </p>
                        <p class="mt-3">
                            Bestätigungsmail jetzt neu senden
                        </p>
                        <b-button type="submit" class="mt-2 text-uppercase" variant="light"  @click.prevent="handlResendVerification">Neu Senden</b-button>
                        <div v-if="resendMailError" class="d-block text-center" v-html="resendMailError"></div>
                    </div>
                </b-col>
            </b-row>
        </b-container>
  </b-container>
</template>


<script>

export default {
    name:'ShopLoginView',
    components: {

    },
    data() {
        return {
            login: '',
            password: '',
            loginError: '',
            showResendMail: false,
            resendMailError: ''
        }
    },
    computed: {
        getSelectedLanguage() {
            return this.$store.getters.getLanguage;
        },
        getLanguageItem: function() {
            return this.$store.getters.getLanguageStrings;
        },
        emailState(){

            if (this.login.length == 0) {
                return undefined;
            }else if(this.login.match(this.$store.getters.getMailFormat) ){
                return true;
            }else{
                return false;
            }
        },
    },
    methods:{
        async PostLogintoServer(login, pw) {
            let config = JSON.parse(JSON.stringify(this.$store.getters.getRestHeaderConfig));

            config.params = undefined; // make sure they are empty
            // prepare Parameters
            let params = {
                username: login, // this.login.trim(),
                password: pw, // this.password.trim(),
            };

           // console.log('Post Login:', params, config);

        await this.$http
            .post(this.$store.getters.getRestServerBaseUrl + "/login" , params , config)
            .then(response => {
               // console.log('Login OK: ', response);
                this.$store.dispatch('setCustomerLoginStatus', {customerName:this.login, loggedIn: true });

                this.loginError = '<span class="text-success">Anmeldung erfolgreich</span>';

                this.showResendMail = false;
                response.data ='';

                // go Back to last route...?
                if(this.$store.getters.getPreviousRoute != undefined){

                   // console.log('go Back: ', this.$store.getters.getPreviousRoute );
                    this.$router.push(this.$store.getters.getPreviousRoute.from );
                }else{
                  //  console.log('No prev Route, goto /');
                    this.$router.push('/');
                }

            })
            .catch(err => {
                console.log("POST Login failed: ", err.response);

                this.loginError = '<span class="text-danger">Anmeldung fehlgeschlagen</span> ';

                if(err.response.data.errorText =='email not verified'){
                    // show some resend mail button
                    this.showResendMail = true;
                }else{
                    // return error to gui
                    this.loginError +='<div class="mt-3 text-monospace">Fehlerbeschreibung: ' + err.response.data.errorText + '</div>';
                }
            });
        },
        async PostResendVerificationMailToServer(login) {
            let config = JSON.parse(JSON.stringify(this.$store.getters.getRestHeaderConfig));

            config.params = undefined; // make sure they are empty
            // prepare Parameters
            let params = {
                emailAddress: login, // this.login.trim(),
            };

          //  console.log('Post Resend Mail:', params, config);

        await this.$http
            .post(this.$store.getters.getRestServerBaseUrl + "/resendEmailVerification" , params , config)
            .then(response => {
              //  console.log('ReSend Mail OK: ', response);
                this.resendMailError = '<span class="text-success">E-Mail an '+ login+ ' verschickt</span> ';
               response.data ='';

            })
            .catch(err => {
                console.log("POST ReSend failed: ", err.response);
                 this.resendMailError = '<span class="text-danger">Neu Anfordern fehlgeschlagen</span> ';

            });
        },
        handleSubmit() {
            // check input
            if(this.login.trim() != '' && this.password.trim() != ''){
               // console.log('Try Login:', this.login.trim());

                this.PostLogintoServer(this.login.trim(), this.password.trim());
            }else{
               // console.log('Login or password missing!');
                // send Visual Error somewhere ?
                this.loginError = '<span class="text-danger">Bitte überprüfen Sie Ihre Eingaben</span>';
            }
        },
        handlResendVerification(){
            if(this.login.trim() != '' && this.login.match(this.$store.getters.getMailFormat)){
               // console.log('Try Resend:', this.login.trim());
                this.resendMailError = '';
                this.PostResendVerificationMailToServer(this.login);

            }else{
               // console.log('Login or password missing!');
                this.resendMailError = '<span class="text-danger">E-Mail Adresse überprüfen</span> ';
            }
        }
    },
    mounted(){
        window.scroll({
            top: 0,
            left: 0,
            behavior: 'smooth'
        });
    }

}
</script>
